function submitSearchForm() {
  $('input[name="post_type"]').on('click', function () {
    $(this).closest('form').submit();
  });


  setTimeout(function() { $('.search-header-module #search-field').focus() }, 500);
}

export { submitSearchForm }


// WEBPACK FOOTER //
// ./scripts/pages/search.js